import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

//Constants
import { GenderConst } from '../../planner-edit/constants/Gender.const';

@Component({
  selector: 'buy-demo',
  templateUrl: './buy-demo.component.html',
  styleUrls: ['./buy-demo.component.scss']
})
export class BuyDemoComponent implements OnInit {
  @Input() group: FormGroup;

  ageList = new Array(100);
  genderConst = GenderConst;

  constructor() { }

  ngOnInit() {
  }
}
